import { createApi } from "@reduxjs/toolkit/query/react";

import { baseQuery } from "../../../shared/api/base-query";
import { PagedResponseDto } from "../../../shared/dtos/paged-response.dto";
import { ITechWorkDto } from "../shared/dtos/tech-work.dto";
import type { ITechWorksRequest } from "../shared/interfaces/tech-works-request";

import { TECH_WORKS_LIST_TAG, TECH_WORKS_TAG_TYPE } from "./constants";

export const techWorksApiSlice = createApi({
  reducerPath: "api-tech-works",
  baseQuery,
  tagTypes: [TECH_WORKS_TAG_TYPE],
  endpoints: (builder) => ({
    techWorkTechAssetNames: builder.query<string[], void>({
      query: () => ({
        url: "TechWorks/UniqueTechAssetNames",
        method: "GET",
      }),
    }),
    techWorkTrailerAssetNames: builder.query<string[], void>({
      query: () => ({
        url: "TechWorks/UniqueTrailerAssetNames",
        method: "GET",
      }),
    }),
    techWorkDriverFullNames: builder.query<string[], void>({
      query: () => ({
        url: "TechWorks/UniqueDriverFullNames",
        method: "GET",
      }),
    }),
    techWorksList: builder.query<PagedResponseDto<ITechWorkDto>, ITechWorksRequest>({
      query: (params) => ({
        url: "TechWorks",
        method: "GET",
        params,
      }),
      providesTags: (result) =>
        result
          ? [
              ...result.data.map(({ id }) => ({ ...TECH_WORKS_LIST_TAG, id })),
              TECH_WORKS_LIST_TAG,
            ]
          : [TECH_WORKS_LIST_TAG],
    }),
  }),
});

export const {
  useTechWorksListQuery,
  useTechWorkTechAssetNamesQuery,
  useTechWorkTrailerAssetNamesQuery,
  useTechWorkDriverFullNamesQuery,
} = techWorksApiSlice;
